import { Mail, MessageCircle, Phone } from "lucide-react";
import { contactHref } from "../lib/contactAction";

export const VenueContacts = ({ contacts = [], showGoogleMissing = false, testId, onCall, allowCalling = true }) => {
  const knownGoogle = contacts.some((contact) => contact.source === "Google Maps" && contact.type === "phone");
  return <section className="venue-detail-block venue-contact-section" data-testid={`${testId}-section`}>
    <h3 className="section-label">CONTATTI DEL LOCALE</h3>
    {showGoogleMissing && !knownGoogle && <p className="contact-missing" data-testid={`${testId}-google-missing`}>Google Maps · telefono non trovato</p>}
    {contacts.length ? <div className="contact-list">{contacts.map((contact, index) => {
      const href = contactHref(contact);
      const Icon = contact.type === "email" ? Mail : contact.type === "whatsapp" ? MessageCircle : Phone;
      return <div className="contact-row" key={`${contact.source}-${contact.type}-${contact.value}-${index}`} data-testid={`${testId}-row-${index}`}>
        <Icon size={17} aria-hidden="true" />
        <span className="contact-copy"><small data-testid={`${testId}-source-${index}`}>{contact.source} · {contact.kind || (contact.type === "email" ? "email" : "recapito")}</small>
          {href && (contact.type === "email" || allowCalling) ? <a href={href} onClick={onCall && contact.type !== "email" ? (event) => {
            event.preventDefault(); onCall(contact);
          } : undefined} target={contact.type === "whatsapp" ? "_blank" : undefined}
            rel={contact.type === "whatsapp" ? "noopener noreferrer" : undefined}
            data-testid={`${testId}-link-${index}`}>{contact.display || contact.value}</a>
            : <strong data-testid={`${testId}-value-${index}`}>{contact.display || contact.value}</strong>}</span>
      </div>;
    })}</div> : <p className="venue-no-meetings" data-testid={`${testId}-empty`}>Nessun recapito trovato.</p>}
  </section>;
};